import * as React from 'react';
import { PrimaryButton, Link } from 'office-ui-fabric-react/lib/index';
import classnames from 'classnames'
import Wrapper from './Wrapper'
import { clientLog, apiLink, apiGetAccount } from '../util'

export interface Props {
	error?: boolean;
	onDone: (account: any) => void;
	userIdentityToken: string;

}

export interface State {
	trying: boolean;
}

export default class Setup extends React.Component<Props, State> {
	constructor(props, context) {
		super(props, context);
		this.state = {
			trying: false
		};
	}

	startChecking = async () => {
		setTimeout(this.doCheck, 2500);

	}

	doCheck = async () => {
		if (!this.state.trying) {
			return;
		}

		clientLog("Waiting for set up to complete");

		var linkResult = await apiLink(
			window.location.href,
			this.props.userIdentityToken,
			null,
			null,
			Office.context.mailbox.diagnostics.hostName
		);

		if (linkResult.success && !linkResult.completeSetup) {

			var account = await apiGetAccount();

			if (account.setupComplete) {
				clientLog("Account set up is complete");
				this.setState({ trying: false });
				this.props.onDone(account);
			} else {
				if (this.state.trying) {
					setTimeout(this.doCheck, 2500);
				}
			}
		} else {
			if (this.state.trying) {
				setTimeout(this.doCheck, 2500);
			}
		}

	}

	render() {
		const {
			error,
			userIdentityToken
		} = this.props;

		const {
			trying,
		} = this.state;

		return (
			<Wrapper
				account={null}
				className={classnames("mm-view mm-message mm-setup", { "-error": error })}>
				<p className="ms-font-xxl -title">Set up your account</p>
				<p className="ms-font-l -message">Welcome to MailMerge365. Let's get you set up and ready to send your first campaign.</p>
				<p className="ms-font-m -message">In order to schedule and send emails on your behalf, we are going to connect to your Office365 account and mailbox.</p>

				<div className="mm-para">
					{!trying && <PrimaryButton
						target="_blank"
						href={"/login?setup=true&jwt=" + encodeURIComponent(userIdentityToken)}
						onClick={() => this.setState({ trying: true }, () => this.startChecking())}
					>Connect with Microsoft 365</PrimaryButton>}
					{trying && <PrimaryButton
						target="_blank"
						onClick={() => this.doCheck()}
					>Waiting for set up to complete</PrimaryButton>}
				</div>

				<p className="ms-font-s -message">Once you click the button a new page will open asking you to sign-in with your Microsoft 365 account. When you've completed that step you can return to this window and start working with MailMerge365.</p>

				<p><a href="https://mm365.me/setup-plugin" target="_blank">More Information</a></p>
			</Wrapper>
		);
	}
}
